import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import Button from '../../../ui/Button';
import Heading from '../../../ui/Heading';
import WhiteCard from '../../../ui/WhiteCard';
import AvatarImage from '../../../ui/AvatarImage';
import CreateProjectModal from '../../projects/CreateProjectModal';
import Modal from '../../../ui/Modal';
import { getOrganizationMembers, getOrganizationStats } from '../../../apis/oragnisations/organisation';
import { useEffect, useState } from 'react';
import Loader from '../../../ui/Loader';
import InviteMemberModal from '../../members/InviteMemberModal';
import { useLoadingState } from '../../../hooks/useLoader';
import ButtonNew from '../../../ui/ButtonNew';

function LeftSection({ roles, orgMembers, stats }) {
    const navigate = useNavigate();
    const { loading, startLoading, stopLoading } = useLoadingState();
    // const [orgMembers, setOrgMembers] = useState([]);
    // const [stats, setStats] = useState({});
    const { id } = useParams();
    const isAdmin = roles.includes('isAdmin');
    const isBountyManager = roles.includes('isBountyManager');
    const isBountyValidator = roles.includes('isBountyValidator');
    const isTreasurer = roles.includes('isTreasurer');
    // useEffect(
    //     function () {
    //         const fetchData = async () => {
    //             try {
    //                 startLoading();
    //                 const [response5, response1] = await Promise.all([
    //                     getOrganizationStats(id),
    //                     getOrganizationMembers(id),
    //                 ]);

    //                 console.log(response5, response1, 'get fund allocated');
    //                 setStats(response5);
    //                 setOrgMembers(response1);
    //                 stopLoading();
    //             } catch (error) {
    //                 console.error(error, 'erroe');
    //             }
    //         };
    //         fetchData();
    //     },
    //     [id]
    // );

    const { liveBountyCount, liveProjectCount, proposalCount, requestCount, liveEventCount, unvalidatedBountyCount } =
        stats;

    return (
        <div className="">
            {isAdmin && (
                <WhiteCard className="px-6 py-5">
                    {!loading ? (
                        <div>
                            <div className="flex justify-between items-center">
                                <Heading className={'text-textPrimary font-medium'} type={'large'}>
                                    Members & Roles
                                </Heading>

                                <Modal>
                                    <Modal.Button
                                        className="flex gap-2 cursor-pointer items-center"
                                        opens={'invitemember'}
                                    >

                                        <ButtonNew
                                            variant="blue"
                                            size="sm"

                                        >
                                            Add Member
                                        </ButtonNew>
                                    </Modal.Button>
                                    <Modal.Window name={'invitemember'}>
                                        <InviteMemberModal orgMembers={orgMembers} />
                                    </Modal.Window>
                                </Modal>
                            </div>
                            <div className="flex justify-between items-end mt-7">
                                <div className="flex -space-x-4 rtl:space-x-reverse">
                                    {orgMembers.slice(0, 4).map((member, index) => {
                                        const relativeLeft = `-left-${4 * index}`;

                                        return (
                                            <div key={member.profileImage + index}>
                                                {/* <img
                                                    className="w-12 h-12 border-2 border-white rounded-full "
                                                    src={member.profileImage}
                                                    alt=""
                                                /> */}

                                                <AvatarImage
                                                    className="border-2 border-borderUnderline"
                                                    w="w-12"
                                                    h="h-12"
                                                    url={member.profileImage}
                                                />
                                            </div>

                                            // <AvatarImage
                                            //     key={member.uid + index + Math.random()}
                                            //     className={`border-2 border-white relative ${relativeLeft} `}
                                            //     w="w-[48px]"
                                            //     h="h-[48px]"
                                            //     url={member.profileImage}
                                            // />
                                        );
                                    })}
                                    {orgMembers.length > 4 && (
                                        <span
                                            onClick={() => navigate('view-members')}
                                            className="flex items-center justify-center w-12 h-12 text-xs font-medium text-white bg-[#06B6D4] cursor-pointer border-2 border-borderUnderline rounded-full  "
                                            href="#"
                                        >
                                            +{orgMembers.length - 4}
                                        </span>
                                    )}
                                </div>
                                <ButtonNew onClick={() => navigate('view-members')} variant="transparent" size="sm">
                                    View Members &gt;{' '}
                                </ButtonNew>

                            </div>
                        </div>
                    ) : (
                        <Loader />
                    )}
                </WhiteCard>
            )}
            {(isAdmin || isBountyManager) && (
                <WhiteCard className="py-5 px-6">
                    {!loading ? (
                        <>
                            <div className="flex justify-between items-center">
                                <Heading className={'text-textPrimary  font-medium'} type={'large'}>
                                    Bounties
                                </Heading>

                                <ButtonNew
                                    variant="blue"
                                    size="sm"
                                    onClick={() => navigate(`/${id}/createBounty`)}
                                >
                                    Add Bounty
                                </ButtonNew>
                            </div>
                            <div className="flex justify-between items-end mt-7">
                                <div className="flex  gap-2 flex-col">
                                    <p className="text-textPrimary text-5xl font-medium ">{liveBountyCount || 0}</p>
                                    <p className="text-textSecondary">Live Bounties</p>
                                </div>

                                <ButtonNew onClick={() => navigate('view-bounties')} variant="transparent" size="sm">
                                    View Bounties &gt;{' '}
                                </ButtonNew>

                            </div>
                        </>
                    ) : (
                        <Loader />
                    )}
                </WhiteCard>
            )}

            {(isAdmin || isBountyManager) && (
                <WhiteCard className="py-5 px-6">
                    {!loading ? (
                        <>
                            <div className="flex justify-between items-center">
                                <Heading className={'text-textPrimary font-medium'} type={'large'}>
                                    Projects
                                </Heading>

                                <Modal>
                                    <Modal.Button
                                        className="flex gap-2 cursor-pointer items-center"
                                        opens={'createproject'}
                                    >

                                        <ButtonNew
                                            variant="blue"
                                            size="sm"

                                        >
                                            Add Project
                                        </ButtonNew>
                                    </Modal.Button>
                                    <Modal.Window name={'createproject'}>
                                        <CreateProjectModal />
                                    </Modal.Window>
                                </Modal>
                            </div>
                            <div className="flex justify-between items-end mt-7">
                                <div className="flex  gap-2 flex-col">
                                    <p className="text-textPrimary text-5xl font-medium ">{liveProjectCount || 0}</p>
                                    <p className="text-textSecondary">Live Projects</p>
                                </div>
                                <ButtonNew onClick={() => navigate('view-projects')} variant="transparent" size="sm">
                                    View Projects &gt;{' '}
                                </ButtonNew>

                            </div>
                        </>
                    ) : (
                        <Loader />
                    )}
                </WhiteCard>
            )}
            {(isAdmin || isBountyManager) && (
                <WhiteCard className="py-5 px-6">
                    {!loading ? (
                        <>
                            <div className="flex justify-between items-center">
                                <Heading className={'text-textPrimary font-medium'} type={'large'}>
                                    Events
                                </Heading>


                                <ButtonNew
                                    variant="blue"
                                    size="sm"
                                    onClick={() => navigate(`/${id}/createevent`)}
                                >
                                    Add Event
                                </ButtonNew>
                            </div>
                            <div className="flex justify-between items-end mt-7">
                                <div className="flex  gap-2 flex-col">
                                    <p className="text-textPrimary text-5xl font-medium ">{liveEventCount || 0}</p>
                                    <p className="text-textSecondary">Live Events</p>
                                </div>
                                <ButtonNew onClick={() => navigate('view-events')} variant="transparent" size="sm">
                                    View Events &gt;{' '}
                                </ButtonNew>

                            </div>
                        </>
                    ) : (
                        <Loader />
                    )}
                </WhiteCard>
            )}
            {/* {(isAdmin || isTreasurer) && (
                <WhiteCard className="py-5 px-6">
                    {!loading ? (
                        <>
                            <div className="flex justify-between items-center">
                                <Heading className={'text-textPrimary font-medium'} type={'large'}>
                                    Proposals & Requests
                                </Heading>
                            </div>
                            <div className="flex justify-between items-end mt-7">
                                <div className="flex items-center gap-7">
                                    <div className="flex  gap-2 flex-col">
                                        <p className="text-textPrimary text-5xl font-medium ">{proposalCount}</p>
                                        <p className="text-textSecondary">Proposals</p>
                                    </div>
                                    <div className="flex  gap-2 flex-col">
                                        <p className="text-textPrimary text-5xl font-medium ">{requestCount}</p>
                                        <p className="text-textSecondary">Requests</p>
                                    </div>
                                </div>

                                <Button
                                    onClick={() => navigate('view-proposalsandrequests')}
                                    className=" w-36 text-end"
                                    size="none"
                                    variant="transparent"
                                >
                                    View All &gt;{' '}
                                </Button>
                            </div>
                        </>
                    ) : (
                        <Loader />
                    )}
                </WhiteCard>
            )} */}
            {(isAdmin || isBountyValidator) && (
                <WhiteCard className="py-5 px-6">
                    {!loading ? (
                        <>
                            <div className="flex justify-between items-center">
                                <Heading className={'text-textPrimary font-medium'} type={'large'}>
                                    Validation
                                </Heading>
                            </div>
                            <div className="flex justify-between items-end mt-7">
                                <div className="flex  gap-2 flex-col">
                                    <p className="text-textPrimary text-5xl font-medium ">{unvalidatedBountyCount || 0}</p>
                                    <p className="text-textSecondary">Unvalidated bounties</p>
                                </div>
                                <ButtonNew onClick={() => navigate('validation')} variant="transparent" size="sm">
                                    View Validations &gt;{' '}
                                </ButtonNew>

                            </div>
                        </>
                    ) : (
                        <Loader />
                    )}
                </WhiteCard>
            )}
        </div>
    );
}

export default LeftSection;
